<template>
  <div class="container">
    <div class="details-page trans">
      <details-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">论文信息</h2>
        <div class="information shadow">
          <p class="items">
            <span class="lt-tit">论文编号:{{ this.inform.id }}</span>
          </p>
          <p class="items">
            <span class="lt-tit">论文题目:{{ this.inform.title }}</span>
          </p>
          <p class="items">
            <span class="lt-tit"
              >第一作者姓名:{{ this.inform.authorname }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit"
              >第一作者电话:{{ this.inform.authorphone }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit"
              >第一作者单位:{{ this.inform.authorcompany }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit"
              >通讯作者姓名:{{ this.inform.corauthorname }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit"
              >通讯作者电话:{{ this.inform.corauthorphone }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit"
              >通讯作者邮箱:{{ this.inform.corauthoremail }}</span
            >
          </p>
          <p class="items">
            <span class="lt-tit">已上传稿件:</span>
            <PapersUpload
              :uploadFileList="this.inform.file_metadata"
              :readOnly="true"
            ></PapersUpload>
          </p>
        </div>
        <div class="timer shadow">
          <p class="items">
            <span class="lt-tit">审核状态:{{ this.inform.status }}</span>
          </p>
          <!-- <p class="items"><span class="lt-tit">审核时间: {{$moment(this.inform.update_time).format('YYYY年MM月DD日 HH时mm分ss秒')}}</span></p> -->
        </div>
      </div>
      <div class="main">
        <!-- <h2 class="edit"  @click="editInfo()"></h2> -->
        <el-button
          @click="editInfo()"
          :style="updateBtnStyle"
          v-if="(!this.inform.ismodified && this.inform.status == '修改稿件') || this.inform.status == '已投稿'"
          >修改论文信息</el-button
        >
        <el-button
          @click="delInfo()"
          style="width: 45%; background: #fe0000; color: #fff; border: none;margin-left:10%"
          v-if="this.inform.status == '已投稿'"
          >删除</el-button
        >
        <el-button
          disabled
          style="width: 100%; background: #fe0000; color: #fff; border: none"
          v-if="this.inform.ismodified"
          >已修改论文信息</el-button
        >
        <el-button
          disabled
          style="width: 100%; background: #fe0000; color: #fff; border: none"
          v-if="!this.inform.ismodified && this.inform.status !== '修改稿件' && this.inform.status !== '已投稿'"
          >处于已投稿或修改稿件状态才能修改论文信息</el-button
        >
      </div>
      <el-dialog
        title="提示"
        :visible.sync="delDialogVisible"
        width="80%"
        center>
        <span>确定删除？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delDialogVisible = false">取 消</el-button>
          <el-button style="color: white;background-color: #fe0000;" @click="confirmDelete">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import PapersUpload from "@/components/upload"
  import detailsHeader from "@/components/header"
  import { Contributions } from "@/store/entity/contributions"

  export default {
    name: "detailsPage",
    inform: {},
    components: {
      detailsHeader,
      PapersUpload,
    },

    data() {
      return {
        
        delDialogVisible:false,
        deleteitem:null,
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "投稿详情",
        },
        inform: new Contributions(), // 投稿信息
      }
    },
    computed:{
      updateBtnStyle(){
        if(this.inform.status=="已投稿"){
          return {width:'45%', background: '#fe0000', color: '#fff', border: 'none'}
        }else{
          return {width:'100%', background: '#fe0000', color: '#fff', border: 'none'}
        }
      },
    },
    created() {
      if (this.$route.params.inform) {
        this.inform = this.$route.params.inform
      } else if (this.$route.query.paper_id) {
        Contributions.getById(this.$route.query.paper_id).then((item) => {
          this.inform = item
        })
      } else {
        // pass
      }
    },

    methods: {
      handleClickIocn() {
        this.$router.push({ name: "paper" })
      },
      editInfo(item) {
        this.$router.push({
          name: "contributions",
          params: { inform: this.inform },
          query: { paper_id: this.inform.id },
        })
      },
      delInfo(){
        this.delDialogVisible = true
      },
      confirmDelete(){
        Contributions.delete(this.inform.id).then(()=>{
          this.delDialogVisible = false;
          this.$router.push({ name: "paper" })
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .tit {
      padding-left: 5px;
      font-size: 16px;
      margin-top: 30px;
      border-left: 3px solid var(--main-color);
      font-weight: bold;
      color: var(--main-color);
    }
    .edit {
      color: var(--main-color);
      font-weight: bold;
    }

    .information,
    .timer {
      border-radius: 5px;
      box-sizing: border-box;
      padding: 15px;
      margin-top: 15px;
      background: #fff;

      .items {
        margin-top: 10px;
        line-height: 30px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
</style>
